<template>
  <v-form class="d-flex flex-column" ref="form" v-model="validForm">
    <v-text-field
      v-model="email"
      autocomplete="off"
      label="Email address"
      :error-messages="emailErrorMessageText"
      bg-color="white"
      :autofocus="true"
      variant="solo"
      @blur="validateEmail()"
      @keydown.enter.prevent="submitEmail"
    />

    <PPrimaryButton
      class="mt-1 continue-btn px-8"
      :loading="loading"
      :color="PwcTheme.colors.darkGreyButton"
      @click="submitEmail"
      :disabled="authenticationStore.tokenSent"
    >
      Continue
    </PPrimaryButton>
  </v-form>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { RouterPath } from "@/models/enum/routerPath";
import { useRouter } from "vue-router";
import { sendToken, sendContextToken } from "@/services/authService";
import { useSnackBarStore } from "@/stores/snackBarStore";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import { PwcTheme } from "@/plugins/pwc-theme";

const router = useRouter();
const authenticationStore = useAuthenticationStore();
const snackbarStore = useSnackBarStore();

const email = ref(authenticationStore.email);
const loading = ref(false);

const validForm = ref(true);
const validEmail = ref(true);

const emailErrorMessageText = computed(() =>
  validEmail.value ? "" : "Invalid email"
);

onMounted(() => {});

function validateEmail(): void {
  validEmail.value = !!email.value && /.+@.+\..+/.test(email.value);
  validForm.value = validEmail.value;
}

async function submitEmail() {
  validateEmail();
  if (validForm.value) {
    authenticationStore.email = email.value;
    try {
      loading.value = true;
      authenticationStore.hasContext
        ? await sendContextToken(authenticationStore.context, email.value)
        : await sendToken(email.value);

      router.push(RouterPath.LoginLinkSent);
    } catch (error) {
      snackbarStore.showError("Unable to send login link");
    } finally {
      loading.value = false;
    }
  }
}
</script>

<style scoped lang="scss">
.continue-btn {
  width: fit-content;
  align-self: flex-end;
}
</style>
